import _ from 'lodash';
import { PartiesEntity } from '../../../../classes/Parties/Parties.entity';
import { PartiesService } from '../../../details_expedient/modals/partiesLocalModal/services/partiesServices';

/** Campos obligatorios del turnado interno de un expediente existente. */
export const INTERNAL_TURN_REQUIRED_FIELDS = ['expedient_number', 'receiver_id'];

/**
 * Partes del expediente en el formato de PartsRelatedToTheExpedientTable.
 */
export const mapPartiesForInternalTurn = (partiesList = []) =>
  partiesList.map((item) => {
    const partyData = item.party_data || {};
    const {
      names = '',
      maternal_surname = '',
      paternal_surname = '',
      bussiness_name = '',
    } = partyData;
    const resolvedName =
      `${names || item.full_name || item.name || ''} ${paternal_surname} ${maternal_surname}`.trim();
    return {
      party_type: item.party_type,
      bussiness_name: bussiness_name || '',
      names: resolvedName,
    };
  });

export const getPartiesForInternalTurn = async (expedientId) => {
  const partiesList = await PartiesEntity.getPartiesList(expedientId);
  return mapPartiesForInternalTurn(partiesList) || [];
};

/**
 * Datos que se envían a government_books/release al turnar un expediente
 * existente: el tipo de juicio, la vía y la materia no cambian en un turnado, y
 * las partes agregadas en el modal viajan en parties_array.
 */
export const buildInternalTurnPayload = (transfer) => ({
  ..._.omit(transfer, ['via', 'kind_judgment', 'matter']),
  parties_array: PartiesService.getParties(),
});
